import React, { useState } from 'react';
import YouTube from 'react-youtube';
import './VideoPlayer.css';

const VideoPlayer = ({ video, onComplete, isCompleted }) => {
  const [playerReady, setPlayerReady] = useState(false);

  // Extract YouTube video ID from URL
  const getYouTubeId = (url) => {
    if (!url) return null;

    // Handle different YouTube URL formats
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : url;
  };

  const videoId = video.youtube_id || getYouTubeId(video.youtube_url);

  const opts = {
    height: '480',
    width: '100%',
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
    },
  };

  const onReady = (event) => {
    setPlayerReady(true);
  };

  const onEnd = (event) => {
    if (!isCompleted && onComplete) {
      onComplete();
    }
  };

  return (
    <div className="video-player-container">
      <div className="video-header">
        <h2>{video.title}</h2>
        {isCompleted && <span className="completed-badge">Completed ✓</span>}
      </div>

      {video.description && (
        <p className="video-description">{video.description}</p>
      )}

      <div className="video-wrapper">
        {videoId ? (
          <YouTube
            videoId={videoId}
            opts={opts}
            onReady={onReady}
            onEnd={onEnd}
            className="youtube-player"
          />
        ) : (
          <div className="video-error">
            Invalid video URL. Please contact the instructor.
          </div>
        )}
      </div>

      {!isCompleted && playerReady && (
        <button onClick={onComplete} className="btn-primary mark-complete-btn">
          Mark as Complete
        </button>
      )}
    </div>
  );
};

export default VideoPlayer;
